// extracted by mini-css-extract-plugin
var _1 = "UserEditAddressFormModalFields-moduleactionRow__kdFg_";
var _2 = "UserEditAddressFormModalFields-moduleaddedAddressHeader__K99Qk";
var _3 = "UserEditAddressFormModalFields-moduleaddedAddressList__bBGvV";
var _4 = "UserEditAddressFormModalFields-modulecolumn__NVzAX";
var _5 = "UserEditAddressFormModalFields-moduleemptyAddress__D_AWb";
var _6 = "UserEditAddressFormModalFields-moduleformFieldsContainer__YEVih FormFieldsContainer-moduleFormFieldsContainer__u1JJu";
var _7 = "UserEditAddressFormModalFields-moduleformFieldsWrapper__k3Y_f";
var _8 = "UserEditAddressFormModalFields-moduleseparator__x83PR";
export { _1 as "actionRow", _2 as "addedAddressHeader", _3 as "addedAddressList", _4 as "column", _5 as "emptyAddress", _6 as "formFieldsContainer", _7 as "formFieldsWrapper", _8 as "separator" }
